import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  MenuItem,
  Select,
  Typography,
  styled,
  Button,
} from "@mui/material";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import {
  DataTable,
  ProgressBarWithColors,
  SmoothModal,
} from "../../../components";
import { Iconify } from "../../../utilities";
import { useAAFFs } from "../../../hooks";
import FiltrosAAFF from "../../../components/filtros/filtrosAAFF";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { Link } from "react-router-dom";
import { formatoFechas, formatoFechasEs } from "../../../functions/funciones";
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';


const ColorButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#92004D",
  "&:hover": {
    backgroundColor: "#92004D",
  },
  alignItems: "center",
}));

const AAFF = () => {
  const { t } = useTranslation(['aaff', 'properties', 'common']);
  const user = useContext(UsuarioContext);

  const motivosNoVisita = [
    t('properties:noVisit.reasons.noRenewalVisit'),
    t('properties:noVisit.reasons.notYetVisits'),
  ];

  const [recargar, setRecargar] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [motivoNoVisita, setMotivoNoVisita] = useState(motivosNoVisita[0]);
  const { loading, data, fetchData } = useAAFFs();
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva,setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);


  const handleOpenNewTab = ({ nif }) => {
    if (!nif) return;
    window.open(`aaff/${nif}/comunidades`, "_top");
  };

  const handlePagination = ({ offset, limit }) => {
    const { id } = user
    // setPagination({ page: offset, limit });
    fetchData({ offset, limit, filtros:busqueda });
  };

  const handleOpenModal = () => setOpenModal(true);

  const closeModal = () => setOpenModal(false);

  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.admin'),
      overrideFunc: (data, row) => (
        <Link to= {`/aaff/${row.nif}/comunidades`}>
          {data}
        </Link>
      )
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('common:form.nif').toUpperCase(),
      overrideFunc: (data, row) => row.parent_id ? "" : (
        <Link to= {`/aaff/${row.nif}/comunidades`}>
          {data}
        </Link>
      )
    },
    {
      id: "telefono",
      numeric: false,
      disablePadding: false,
      label: t('common:form.phone').toUpperCase(),
    },
  ];

  useEffect(() => {
    setRecargar(false);
  }, [recargar]);

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
    // fetchData({ offset: 1, limit: limite, filtros: filtros });
  } 

  return (
    <>
      <SmoothModal open={openModal} onClose={closeModal}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography variant="h5" fontWeight={"bold"}>
            {t('properties:noVisit.reason')}
          </Typography>

          <Box sx={{ width: "90%" }}>
            <Select
              fullWidth
              displayEmpty
              value={motivoNoVisita}
              onChange={setMotivoNoVisita}
            >
              {motivosNoVisita.map((motivo) => (
                <MenuItem key={motivo} value={motivo}>
                  {motivo}
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Box display={"flex"} flexDirection={"row"} gap={2}>
            <ColorButton>
              <Typography>{t('common:actions.save')}</Typography>
            </ColorButton>
            <Button onClick={closeModal}>{t('common:actions.cancel')}</Button>
          </Box>
        </Box>
      </SmoothModal>
      <BreadCrumb
        rutas={[{ path: "/aaff", label: t('title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
          <div className="gridCard">
              <div className="gridHead">
                  {t('title').toUpperCase()}
              </div>
          </div>
      </div>
      <Box className="pageContent tableContainer">
        <FiltrosAAFF onFilter={filtrarDatos}  clearFilter={clearFilters}  filtrosIniciales={busqueda}/>  
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data?.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data?.current_page}
                meta={data?.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('messages.noAaff')}
              />
            </Box>
          </Box>
        </div>
      </Box>
    </>
  );
};

export default withRouter(AAFF);
